import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { CollectionViewer, DataSource, SelectionChange } from '@angular/cdk/collections';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { map } from 'jquery';

export class DynamicFlatNode {
  constructor(public item: string, public level = 1, public expandable = false,
              public isLoading = false) {}
}

// export class DynamicDataSource implements DataSource<DynamicFlatNode> {

//   dataChange = new BehaviorSubject<DynamicFlatNode[]>([]);

//   get data(): DynamicFlatNode[] { return this.dataChange.value; }
//   set data(value: DynamicFlatNode[]) {
//     this._treeControl.dataNodes = value;
//     this.dataChange.next(value);
//   }

//   // tslint:disable-next-line:variable-name
//   constructor(private _treeControl: FlatTreeControl<DynamicFlatNode>) {}

//   connect(collectionViewer: CollectionViewer): Observable<DynamicFlatNode[]> {
//     this._treeControl.expansionModel.changed.subscribe(change => {
//       if ((change as SelectionChange<DynamicFlatNode>).added ||
//         (change as SelectionChange<DynamicFlatNode>).removed) {
//         this.handleTreeControl(change as SelectionChange<DynamicFlatNode>);
//       }
//     });
//     return merge(collectionViewer.viewChange, this.dataChange).pipe(map(() => this.data));
//   }

//   disconnect(collectionViewer: CollectionViewer): void {}

//   /** Handle expand/collapse behaviors */
//   handleTreeControl(change: SelectionChange<DynamicFlatNode>) {
//     if (change.added) {
//       change.added.forEach(node => this.toggleNode(node, true));
//     }
//     if (change.removed) {
//       change.removed.slice().reverse().forEach(node => this.toggleNode(node, false));
//     }
//   }

//   /**
//    * Toggle the node, remove from display list
//    */
//   toggleNode(node: DynamicFlatNode, expand: boolean) {
//     const children = this._database.getChildren(node.item);
//     const index = this.data.indexOf(node);
//     if (!children || index < 0) { // If no children, or cannot find the node, no op
//       return;
//     }

//     node.isLoading = true;

//     setTimeout(() => {
//       if (expand) {
//         const nodes = children.map(name =>
//           new DynamicFlatNode(name, node.level + 1, this._database.isExpandable(name)));
//         this.data.splice(index + 1, 0, ...nodes);
//       } else {
//         let count = 0;
//         for (let i = index + 1; i < this.data.length
//           && this.data[i].level > node.level; i++, count++) {}
//         this.data.splice(index + 1, count);
//       }

//       // notify the change
//       this.dataChange.next(this.data);
//       node.isLoading = false;
//     }, 1000);
//   }
// }

@ManageType('RecordPanelComponent')
@Component({
  selector: 'app-record-panel',
  templateUrl: './record-panel.component.html',
  styleUrls: ['./record-panel.component.scss']
})
export class RecordPanelComponent implements OnInit {

  treeControl: FlatTreeControl<DynamicFlatNode>;
//  dataSource: DynamicDataSource;

  constructor() {
    // this.treeControl = new FlatTreeControl<DynamicFlatNode>(this.getLevel, this.isExpandable);
//    this.dataSource = new DynamicDataSource(this.treeControl, database);
//    this.dataSource.data = database.initialData();
  }

  ngOnInit(): void {
  }

  getLevel = (node: DynamicFlatNode) => node.level;

  isExpandable = (node: DynamicFlatNode) => node.expandable;

  hasChild = (_: number, nodeData: DynamicFlatNode) => nodeData.expandable;
}
